export const formIDRegex = /^[a-z\d-]+(-[a-z]+)*$/;
export const formNameRegex = /[^a-zA-Z0-9-' ]/g;
export const formLocaleRegex = /^[a-z]{2}-[A-Z]{2}$/;
export const formResourceIdRegex = /[^a-zA-Z0-9-_' ]/g;
